import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetCurrenciesResponse = App.Http.Responses.Currency.GetCurrenciesResponse;
import GetCurrencyResponse = App.Http.Responses.Currency.GetCurrencyResponse;

class CurrencyApi extends TenantBaseApi {
    /**
     * Get list of Currencies
     *
     * - Request: -
     * - Response: GetCurrenciesResponse
     */
    async index(): Promise<GetCurrenciesResponse> {
        return await this.get<GetCurrenciesResponse, void>("/currencies");
    }

    /**
     * Get Currency
     *
     * - Request: { id: number }
     * - Response: GetCurrencyResponse
     */
    async show(currencyId: string): Promise<GetCurrencyResponse> {
        return await this.get<GetCurrencyResponse, void>(`/currencies/${currencyId}`);
    }
}

export const currencyApi = new CurrencyApi();
